import { request } from '../../services';
import { createActions } from 'redux-actions';
import qs from 'qs';

const { warehouseReportSuccess, warehouseReportFailure, warehouseReportRequest } = createActions(
  'WAREHOUSE_REPORT_SUCCESS',
  'WAREHOUSE_REPORT_REQUEST',
  'WAREHOUSE_REPORT_FAILURE',
);

export const requestWarehouseReport = filters => (dispatch) => {
  dispatch(warehouseReportRequest());

  return request(`reports/warehouse_summary?${qs.stringify(filters)}`)
    .then(({ json }) => dispatch(warehouseReportSuccess(json)))
    .catch(error => dispatch(warehouseReportFailure(error)));
};

export function clearWarehouseReport() {
  return { type: 'WAREHOUSE_REPORT_CLEAR' };
}

const { jobHistoryReportSuccess, jobHistoryReportFailure, jobHistoryReportRequest } = createActions(
  'JOB_HISTORY_REPORT_SUCCESS', 'JOB_HISTORY_REPORT_REQUEST', 'JOB_HISTORY_REPORT_FAILURE',
);

export const requestJobHistoryReport = filters => (dispatch) => {
  dispatch(jobHistoryReportRequest());
  return request(`reports/job_history_report?${qs.stringify(filters)}`)
    .then(({ json }) => dispatch(jobHistoryReportSuccess(json)))
    .catch(error => dispatch(jobHistoryReportFailure(error)));
};

export function clearJobHistoryReport() {
  return { type: 'JOB_HISTORY_REPORT_CLEAR' };
}

const {
  installWorkorderReportSuccess,
  installWorkorderReportFailure,
  installWorkorderReportRequest,
} = createActions(
  'INSTALL_WORKORDER_REPORT_SUCCESS',
  'INSTALL_WORKORDER_REPORT_REQUEST',
  'INSTALL_WORKORDER_REPORT_FAILURE',
);

export const requestInstallWorkorderReport = filters => (dispatch) => {
  dispatch(installWorkorderReportRequest());
  return request(`reports/install_workorder_report?${qs.stringify(filters)}`)
    .then(({ json }) => dispatch(installWorkorderReportSuccess(json)))
    .catch(error => dispatch(installWorkorderReportFailure(error)));
};

export function clearInstallWorkorderReport() {
  return { type: 'INSTALL_WORKORDER_REPORT_CLEAR' };
}

const { installerPaperworkSuccess, installerPaperworkFailure, installerPaperworkRequest } =
  createActions(
    'INSTALLER_PAPERWORK_SUCCESS',
    'INSTALLER_PAPERWORK_REQUEST',
    'INSTALLER_PAPERWORK_FAILURE',
  );

export const requestInstallerPaperwork = filters => (dispatch) => {
  dispatch(installerPaperworkRequest());
  return request(`reports/installer_paperwork?${qs.stringify(filters)}`)
    .then(({ json }) => dispatch(installerPaperworkSuccess(json)))
    .catch(error => dispatch(installerPaperworkFailure(error)));
};


export function clearInstallerPaperwork() {
  return { type: 'INSTALLER_PAPERWORK_CLEAR' };
}

const { tagBulkPrintSuccess, tagBulkPrintFailure, tagBulkPrintRequest } =
  createActions(
    'TAG_BULK_PRINT_SUCCESS',
    'TAG_BULK_PRINT_REQUEST',
    'TAG_BULK_PRINT_FAILURE',
  );

export const requestTagBulkPrint = filters => (dispatch) => {
  dispatch(tagBulkPrintRequest());

  return request(`reports/tags_bulk_print?${qs.stringify(filters)}`)
    .then(({ json }) => dispatch(tagBulkPrintSuccess(json)))
    .catch(error => dispatch(tagBulkPrintFailure(error)));
};

export function clearTagBulkPrint() {
  return { type: 'TAG_BULK_PRINT_CLEAR' };
}


const { activityReportSuccess, activityReportFailure, activityReportRequest } = createActions(
  'ACTIVITY_REPORT_SUCCESS',
  'ACTIVITY_REPORT_REQUEST',
  'ACTIVITY_REPORT_FAILURE',
);

export const requestActivityReport = filters => (dispatch) => {
  dispatch(activityReportRequest());

  return request(`reports/activity?${qs.stringify(filters)}`)
    .then(({ json }) => dispatch(activityReportSuccess(json)))
    .catch(error => dispatch(activityReportFailure(error)));
};


export function clearActivityReport() {
  return { type: 'ACTIVITY_REPORT_CLEAR' };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/reports.js